import { Box } from "@mui/material";
import React, { ReactNode, useEffect } from "react";

interface IScrollResetAndTopMarginProps {
  children: ReactNode;
}

export const ScrollResetAndTopMargin = ({
  children,
}: IScrollResetAndTopMarginProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box sx={{ margin: { xs: "56px 0 0 0", sm: "84px 0 0 0" } }}>
      {children}
    </Box>
  );
};
